import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import momentTZ from 'moment-timezone';
import moment from 'moment';

import resources from './translations';

import 'moment/locale/bn';
import 'moment/locale/ja';
import 'moment/locale/km';
import 'moment/locale/ko';
import 'moment/locale/es';
import 'moment/locale/pt';
import 'moment/locale/ro';
import 'moment/locale/ru';
import 'moment/locale/zh-cn';

import * as api from './api';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  fallbackNS: 'translation',
  debug: false,
  resources,
  nsSeparator: '::',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
  ignoreJSONStructure: false, // To retain i18next v19 behavior for now
});

export function changeGlobalMomentLocale(lang: api.Language.Language) {
  moment.locale(lang);
  momentTZ.locale(lang);
}

momentTZ.updateLocale('bn', (moment.localeData('bn') as any)._config);
momentTZ.updateLocale('ja', (moment.localeData('ja') as any)._config);
momentTZ.updateLocale('km', (moment.localeData('km') as any)._config);
momentTZ.updateLocale('ko', (moment.localeData('ko') as any)._config);
momentTZ.updateLocale('es', (moment.localeData('es') as any)._config);
momentTZ.updateLocale('pt', (moment.localeData('pt') as any)._config);
momentTZ.updateLocale('ro', (moment.localeData('ro') as any)._config);
momentTZ.updateLocale('ru', (moment.localeData('ru') as any)._config);
momentTZ.updateLocale('zh-cn', (moment.localeData('zh-cn') as any)._config);
changeGlobalMomentLocale(api.Language.Language.En);

export default i18n;
